
let scrollEventAdded = false;
const activationPoint = 6900;
function initStickyATC() {
  const stickyATC = document.querySelector('.sticky-atc-bar');
  
  if (stickyATC) {
    stickyATC.classList.remove('sticky-atc-bar--show');
    stickyATC.style.opacity = '0';
    stickyATC.classList.add('sticky-atc-bar', 'hidden', 'md:block', 'sticky-atc-bar--with-dynamic-buttons', 'page-width', 'page-width--fixed');
    
    if (!scrollEventAdded) {
      scrollEventAdded = true;
      
      window.addEventListener('scroll', function() {
        if (window.scrollY > activationPoint) {
          stickyATC.classList.add('sticky-atc-bar--show');
          stickyATC.style.opacity = '1';
        } else {
          stickyATC.classList.remove('sticky-atc-bar--show');
          stickyATC.style.opacity = '0';
        }
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', function() {
  initStickyATC();
});
const observer = new MutationObserver(function() {
  const stickyATC = document.querySelector('.sticky-atc-bar');
  
  if (stickyATC) {
    stickyATC.classList.remove('sticky-atc-bar--show');
    stickyATC.classList.add('sticky-atc-bar', 'hidden', 'md:block', 'sticky-atc-bar--with-dynamic-buttons', 'page-width', 'page-width--fixed');
    
    if (window.scrollY > activationPoint) {
      stickyATC.classList.add('sticky-atc-bar--show');
    }
    
    if (!scrollEventAdded) {
      initStickyATC();
    }
  }
});
observer.observe(document.body, {
  childList: true,
  subtree: true,
});





/*

let scrollEventAdded = false;
const activationPoint = 6900;
function initStickyATC() {
  const stickyATC = document.querySelector('.sticky-atc-bar');
  
  if (stickyATC) {
    stickyATC.classList.remove('sticky-atc-bar--show');
    stickyATC.style.opacity = '0';
    stickyATC.classList.add('sticky-atc-bar', 'hidden', 'md:block', 'sticky-atc-bar--with-dynamic-buttons', 'page-width', 'page-width--fixed');
    
    if (!scrollEventAdded) {
      scrollEventAdded = true;
      
      window.addEventListener('scroll', function() {
        if (window.scrollY > activationPoint) {
          stickyATC.classList.add('sticky-atc-bar--show');
          stickyATC.style.opacity = '1';
        } else {
          stickyATC.classList.remove('sticky-atc-bar--show');
          stickyATC.style.opacity = '0';
        }
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', function() {
  initStickyATC();
});
const observer = new MutationObserver(function() {
  const stickyATC = document.querySelector('.sticky-atc-bar');
  
  if (stickyATC) {
    stickyATC.classList.remove('sticky-atc-bar--show');
    stickyATC.classList.add('sticky-atc-bar', 'hidden', 'md:block', 'sticky-atc-bar--with-dynamic-buttons', 'page-width', 'page-width--fixed');
    
    if (window.scrollY > activationPoint) {
      stickyATC.classList.add('sticky-atc-bar--show');
    }
    
    if (!scrollEventAdded) {
      initStickyATC();
    }
  }
});
observer.observe(document.body, {
  childList: true,
  subtree: true,
});


 let scrollEventAdded = false;
let activationPoint = 6900; 

{% if template.name == 'product' and template.suffix == 'saat' %}
  activationPoint = 3200;
{% endif %}

function initStickyATC() {
  const stickyATC = document.querySelector('.sticky-atc-bar');
  
  if (stickyATC) {
    stickyATC.classList.remove('sticky-atc-bar--show');
    stickyATC.style.opacity = '0';
    stickyATC.classList.add(
      'sticky-atc-bar',
      'hidden',
      'md:block',
      'sticky-atc-bar--with-dynamic-buttons',
      'page-width',
      'page-width--fixed'
    );

    if (window.scrollY > activationPoint) {
      stickyATC.classList.add('sticky-atc-bar--show');
      stickyATC.style.opacity = '1';
    } else {
      stickyATC.classList.remove('sticky-atc-bar--show');
      stickyATC.style.opacity = '0';
    }

    if (!scrollEventAdded) {
      scrollEventAdded = true;
      window.addEventListener('scroll', function() {
        if (window.scrollY > activationPoint) {
          stickyATC.classList.add('sticky-atc-bar--show');
          stickyATC.style.opacity = '1';
        } else {
          stickyATC.classList.remove('sticky-atc-bar--show');
          stickyATC.style.opacity = '0';
        }
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initStickyATC();
});

const observer = new MutationObserver(function() {
  const stickyATC = document.querySelector('.sticky-atc-bar');
  
  if (stickyATC) {
    stickyATC.classList.remove('sticky-atc-bar--show');
    stickyATC.style.opacity = '0';
    stickyATC.classList.add(
      'sticky-atc-bar',
      'hidden',
      'md:block',
      'sticky-atc-bar--with-dynamic-buttons',
      'page-width',
      'page-width--fixed'
    );

    if (window.scrollY > activationPoint) {
      stickyATC.classList.add('sticky-atc-bar--show');
      stickyATC.style.opacity = '1';
    } else {
      stickyATC.classList.remove('sticky-atc-bar--show');
      stickyATC.style.opacity = '0';
    }

    if (!scrollEventAdded) {
      initStickyATC();
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});


*/